// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Date$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as CustomActionMenu from "../../../../../../pricing-dashboard/view/components/library/reuseable-components/CustomActionMenu.bs.js";
import * as ModificationActions from "../../../../../../pricing-dashboard/view/components/vm-mapper/ModificationActions.bs.js";
import * as ZoneClusterVmMapper from "../../../../view-model/zone-cluster-campaign/ZoneClusterVmMapper.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../../pricing-dashboard/view/assets/PricingDashboardAssetsManager.bs.js";

var navigate_icon = PricingDashboardAssetsManager.getImage("navigate-icon.svg");

function getClassnameByStatus(status) {
  switch (status) {
    case /* Active */0 :
        return "active";
    case /* Scheduled */1 :
        return "scheduled";
    case /* PendingForReview */2 :
        return "pending";
    
  }
}

function getImageSrcByAction(action) {
  switch (action) {
    case /* Deactivate */0 :
        return PricingDashboardAssetsManager.getImage("deactivate-icon.svg");
    case /* Delete */1 :
        return PricingDashboardAssetsManager.getImage("trash-icon.svg");
    case /* Approve */2 :
        return PricingDashboardAssetsManager.getImage("approve-icon.svg");
    case /* Discard */3 :
        return PricingDashboardAssetsManager.getImage("discard-icon.svg");
    
  }
}

function getMenuItems(actions, setAction) {
  return List.map((function (action) {
                return {
                        text: ModificationActions.toString(action),
                        img_src: getImageSrcByAction(action),
                        action_cb: (function (param) {
                            return Curry._1(setAction, (function (param) {
                                          return action;
                                        }));
                          })
                      };
              }), actions);
}

function getActionsByRoleAndStatus(role, status) {
  var match = role.access_level;
  if (match !== 1) {
    if (match !== 0) {
      return /* [] */0;
    } else if (status >= 2) {
      return {
              hd: /* Approve */2,
              tl: {
                hd: /* Discard */3,
                tl: /* [] */0
              }
            };
    } else {
      return {
              hd: /* Delete */1,
              tl: /* [] */0
            };
    }
  } else if (status >= 2) {
    return {
            hd: /* Delete */1,
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function ZoneClusterTabItem$ActionsMenu(Props) {
  var role = Props.role;
  var status = Props.status;
  var allowedUserAction = Props.allowedUserAction;
  var setAction = Props.setAction;
  if (allowedUserAction === 1) {
    return null;
  }
  var items = getMenuItems(getActionsByRoleAndStatus(role, status), setAction);
  var match = List.length(items);
  if (match !== 0) {
    return React.createElement(CustomActionMenu.make, {
                items: items
              });
  } else {
    return null;
  }
}

var ActionsMenu = {
  getImageSrcByAction: getImageSrcByAction,
  getMenuItems: getMenuItems,
  getActionsByRoleAndStatus: getActionsByRoleAndStatus,
  make: ZoneClusterTabItem$ActionsMenu
};

function getActionTakenMessage(action) {
  switch (action) {
    case /* Deactivate */0 :
        return "Modification will be deactivated from tomorrow, " + Date$Catalyst.toString("Do MMMM", Date$Catalyst.tomorrow(undefined));
    case /* Delete */1 :
        return "Modification will be Deleted on submission";
    case /* Approve */2 :
        return "Modification will be updated from Pending to Scheduled";
    case /* Discard */3 :
        return "Modification will be Discarded on submission";
    
  }
}

function getElegibilityRule(campaign, zones, clusters) {
  var vm = ZoneClusterVmMapper.VMMapper.getViewModel(campaign, zones, clusters);
  if (vm.day_start_time !== "" || vm.day_end_time !== "") {
    return "Time: " + vm.day_start_time + " " + vm.day_end_time + "; Days: " + vm.days_of_week;
  } else {
    return "Days: " + vm.days_of_week;
  }
}

function ZoneClusterTabItem$ModificationSummary(Props) {
  var name = Props.name;
  var action_taken = Props.action_taken;
  var eligibility_rules = Props.eligibility_rules;
  return React.createElement("div", {
              className: "details"
            }, React.createElement(Row$Catalyst.make, {
                  children: React.createElement("div", {
                        className: "title"
                      }, name, action_taken !== undefined ? React.createElement("span", {
                              className: "action-taken-message"
                            }, getActionTakenMessage(action_taken)) : null),
                  className: "title-container"
                }), React.createElement("p", {
                  className: "change-summary"
                }, eligibility_rules));
}

var ModificationSummary = {
  getActionTakenMessage: getActionTakenMessage,
  getElegibilityRule: getElegibilityRule,
  make: ZoneClusterTabItem$ModificationSummary
};

function ZoneClusterTabItem$ModificationPriority(Props) {
  var priority = Props.priority;
  return React.createElement("div", {
              className: "modification-priority"
            }, priority !== undefined ? React.createElement("div", {
                    className: "priority"
                  }, priority) : null);
}

var ModificationPriority = {
  make: ZoneClusterTabItem$ModificationPriority
};

function ZoneClusterTabItem(Props) {
  var allowedUserAction = Props.allowedUserAction;
  var priority = Props.priority;
  var mandatory_campaign = Props.mandatory_campaign;
  var campaign = Props.campaign;
  var selected_geo_region = Props.selected_geo_region;
  var selected_vehicle = Props.selected_vehicle;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var user_role = Props.user_role;
  var open_modal = Props.open_modal;
  var setUpdatedStatus = Props.setUpdatedStatus;
  var dispatch = Props.dispatch;
  var match = React.useState(function () {
        
      });
  var setAction = match[1];
  var action = match[0];
  console.log(dispatch);
  var saveUserAction = function (action) {
    return Curry._1(setUpdatedStatus, (function (prev) {
                  if (prev !== undefined) {
                    return Belt_List.add(prev, {
                                campaign_id: campaign.id,
                                current_status: campaign.status,
                                campaign_status: action
                              });
                  } else {
                    return Belt_List.add(/* [] */0, {
                                campaign_id: campaign.id,
                                current_status: campaign.status,
                                campaign_status: action
                              });
                  }
                }));
  };
  React.useEffect((function () {
          if (action !== undefined) {
            saveUserAction(action);
          }
          
        }), [action]);
  React.useEffect((function () {
          if (allowedUserAction >= 2) {
            
          } else {
            Curry._1(setAction, (function (param) {
                    
                  }));
          }
          
        }), [allowedUserAction]);
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-modification-item"
            }, React.createElement(ZoneClusterTabItem$ModificationPriority, {
                  priority: priority
                }), React.createElement("div", {
                  className: "details-container"
                }, React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "details-wrapper " + getClassnameByStatus(campaign.status)
                    }, React.createElement("img", {
                          className: "navigate-icon",
                          src: navigate_icon,
                          onClick: (function (param) {
                              return Curry._1(open_modal, /* ViewZoneClusterCampaignDetail */{
                                          mandatory_campaign: mandatory_campaign,
                                          modification: campaign,
                                          selected_geo_region: selected_geo_region,
                                          selected_vehicle: selected_vehicle,
                                          zones: zones,
                                          clusters: clusters
                                        });
                            })
                        }), React.createElement(Row$Catalyst.make, {
                          children: null,
                          className: "details-container"
                        }, React.createElement(ZoneClusterTabItem$ModificationSummary, {
                              name: campaign.name,
                              action_taken: action,
                              eligibility_rules: getElegibilityRule(campaign, zones, clusters)
                            }), action !== undefined ? null : React.createElement(ZoneClusterTabItem$ActionsMenu, {
                                role: user_role,
                                status: campaign.status,
                                allowedUserAction: allowedUserAction,
                                setAction: setAction
                              })))));
}

var make = ZoneClusterTabItem;

export {
  navigate_icon ,
  getClassnameByStatus ,
  ActionsMenu ,
  ModificationSummary ,
  ModificationPriority ,
  make ,
  
}
/* navigate_icon Not a pure module */
